// extracted by mini-css-extract-plugin
module.exports = {"root":"FileBtn_root__2vojJ","disabled":"FileBtn_disabled__3A6YZ","warn":"FileBtn_warn__3fhw6","fade":"FileBtn_fade__22ynt"};